export default {
  wrapper: {
    flex: "1",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center"
  }
};



// WEBPACK FOOTER //
// ./src/components/app/not-found/styles.js